<template>
  <div class="info">
    <!-- 固定属性 -->
    <ul>
      <li @click="onChangeInfo('avatar')">
        <span>头像</span>
        <span>
          <img :src="userInfo.avatar" />
        </span>
      </li>
      <li @click="onChangeInfo('nickname')">
        <span>昵称</span>
        <span>{{ userInfo.nickname }}</span>
      </li>
      <li class="mobile">
        <span>手机号</span>
        <span>+{{ userInfo.mobile_code }}-{{ userInfo.mobile }}</span>
      </li>
      <template v-if="mp_login.is_available == 1 && $pub.isWeiXin()">
        <li v-if="!userInfo.wx_openid" class="wechat" @click="bindWx">
          <span>微信</span>
          <span><i>去绑定</i></span>
        </li>
        <li v-else class="wechat" @click="unBindWx">
          <span>微信</span>
          <span>{{ userInfo.wx_nickname }}<i>解除绑定</i></span>
        </li>
      </template>
      <li @click="onChangeInfo('sex')">
        <span>性别</span>
        <span>{{ userInfo.sex_name }}</span>
      </li>
      <li @click="onChangeInfo('birthday')">
        <span>出生日期</span>
        <span :class="{ default_color: userInfo.birthday == '请选择' }">{{
          userInfo.birthday
        }}</span>
      </li>
      <li
        @click="onChangeInfo('address')"
        :class="{ 'no-border': attrs.length == 0 }"
      >
        <span>所在城市</span>
        <span :class="{ default_color: !userInfo.province_id }">
          {{ userInfo.province_name
          }}{{ userInfo.city_name ? ',' + userInfo.city_name : ''
          }}{{ userInfo.district_name ? ',' + userInfo.district_name : '' }}
        </span>
      </li>
    </ul>
    <!-- 动态属性 -->
    <div class="get-user-info">
      <section class="info-content">
        <div
          v-for="(item, index) in attrs"
          :key="index"
          :class="{ noborder: index == attrs.length - 1 }"
        >
          <!-- 单选 -->
          <template v-if="item.type == 1">
            <div class="cell" @click="onChangeInfo('attrs', item)">
              <span>{{ item.attr }}</span>
              <span :class="{ 'span-hover': item.val !== '' }">
                {{ item.val !== '' ? item.value[item.val].text : '请选择' }}
              </span>
            </div>
          </template>
          <!-- 多选 -->
          <template v-else-if="item.type == 2">
            <div class="cell" @click="onChangeInfo('attrs', item)">
              <span>{{ item.attr }}</span>
              <span :class="{ 'span-hover': item.val && item.val.length }">
                {{ getAttrsSelectExtendText(item) }}
              </span>
            </div>
          </template>
          <!-- 日期 -->
          <template v-else-if="item.type == 7">
            <div class="cell" @click="onChangeInfo('attrs', item)">
              <span>{{ item.attr }}</span>
              <span v-if="item.val" class="span-hover">{{
                item.val | formatTime('yyyy-MM-dd')
              }}</span>
              <span v-else>请选择</span>
            </div>
          </template>
          <!-- 时间段 -->
          <template v-else-if="item.type == 8">
            <div class="specail-style">{{ item.attr }}</div>
            <div
              class="cell"
              @click="onChangeInfo('attrs', item, 'start_time')"
            >
              <p class="st1" :class="{ 'span-hover': item.val.start_time }">
                {{ item.val.start_time ? item.val.start_time : '请选择' }}
              </p>
            </div>
            <div class="cell" @click="onChangeInfo('attrs', item, 'end_time')">
              <p class="st1" :class="{ 'span-hover': item.val.end_time }">
                {{ item.val.end_time ? item.val.end_time : '请选择' }}
              </p>
            </div>
          </template>
          <!-- 单行/多/身份证 行文本 -->
          <template v-else>
            <div class="cell" @click="onChangeInfo('attrs', item)">
              <span>{{ item.attr }}</span>
              <span v-if="item.type != 5" :class="{ 'span-hover': item.val }">
                <template v-if="item.type == 9 || item.type == 10">
                  <font :style="{ color: $theme_color }">{{
                    item.val.length ? '查看' : '上传'
                  }}</font>
                </template>
                <template v-else-if="item.type == 6">
                  <font v-if="item.val">{{ item.val | identityCode }}</font>
                  <font v-else>请输入</font>
                </template>
                <template v-else>
                  {{ item.val ? item.val : '请输入' }}
                </template>
              </span>
              <span :class="{ 'span-hover': item.val.province_id }" v-else>
                {{
                  item.val.province_id
                    ? `${item.val.province_name}${item.val.city_name}${item.val.district_name}${item.val.address}`
                    : '请输入'
                }}
              </span>
            </div>
          </template>
        </div>
      </section>
    </div>
    <van-popup v-model="showPopup" position="bottom">
      <ul v-if="changeTag == 'avatar'" class="popup">
        <li @click="onAppUploadImg(1)">
          拍照
          <input
            v-if="!$store.state.app"
            type="file"
            accept="image/*"
            capture="camera"
            @change="onChangeAvatar"
          />
        </li>
        <li @click="onAppUploadImg(2)">
          从手机相册选择
          <input
            v-if="!$store.state.app"
            type="file"
            accept="image/*"
            @change="onChangeAvatar"
          />
        </li>
        <li @click="onCancel">取消</li>
      </ul>
      <div v-else-if="changeTag == 'attrs' || changeTag == 'birthday'">
        <!-- 单选 -->
        <van-picker
          v-if="attrsType == 1"
          :columns="attrsColums"
          :default-index="attrsSelect"
          show-toolbar
          @cancel="onCancel"
          @confirm="onConfirmAttrs"
        />
        <!-- 日期 时间段 -->
        <van-datetime-picker
          v-else-if="attrsType == 7 || attrsType == 8"
          v-model="date_picker.currentDate"
          type="date"
          :min-date="date_picker.minDate"
          :max-date="date_picker.maxDate"
          @cancel="onCancel"
          @confirm="onConfirmBirthday"
        />
      </div>
    </van-popup>
    <Address ref="address" @setAddress="address" from="Info" />
    <!-- 底部信息 -->
    <BottomMessage :position="false"></BottomMessage>
  </div>
</template>

<script>
import Address from '@/components/Address.vue'
import { SexType } from '@/util/enums'
export default {
  name: 'info',
  components: {
    Address,
  },
  data() {
    return {
      userInfo: {},
      showPopup: false,
      changeTag: '',
      date_picker: {
        minDate: new Date(1901, 1, 1),
        maxDate: new Date(2030, 1, 1),
        currentDate: new Date(),
      },
      attrs: [],
      attrsColums: [],
      attrsSelect: -1, // 单选选中，这里为 index 数组
      attrsSelectExtend: [], // 错选选中，这里为 id 数组
      attrsType: -1,
      attrsRequired: false,
      currentItemIdx: -1,
      timeRange: '',
    }
  },
  computed: {
    mp_login() {
      return this.config.mpLogin || {}
    },
    config() {
      return this.$store.state.config
    },
  },
  async created() {
    if (this.$pub.isWeiXin()&&this.$route.query.code) {
      this.$http
        .get('/api/app/userBindingWx', { code: this.$route.query.code })
        .then((res) => {
          this.$toast('绑定成功')
          this.requestUserInfo()
        })
        .catch((_) => {
          this.requestUserInfo()
        })
    } else {
      this.requestUserInfo()
    }
    // 注册连接app的方法
    setTimeout(() => {
      let _this = this
      this.$pub.registerWebViewJavascriptBridge(function(data) {
        _this.requestUpdateUserInfo({ avatar: JSON.parse(data)[0].path })
      })
    }, 500)
  },
  methods: {
    // 标签选择
    onChangeInfo(tag, item, timeRange) {
      this.changeTag = tag
      switch (tag) {
        case 'nickname':
          this.$router.push({
            name: 'SetInfo',
            query: {
              tag,
              value: this.userInfo.nickname,
            },
          })
          return
        case 'sex':
          this.$router.push({
            name: 'SetInfo',
            query: {
              tag,
              value: this.userInfo.sex,
            },
          })
          return
        case 'birthday':
          this.attrsType = 7
          if (this.userInfo[tag])
            this.date_picker.currentDate = new Date(this.userInfo[tag])
          this.date_picker.maxDate = new Date()
          break
        case 'address':
          this.$refs.address.requestArea(this.userInfo)
          return
        case 'attrs':
          this.attrsType = item.type
          this.currentItemIdx = item.idx
          if (item.type == 1) {
            // 单选
            this.attrsColums = item.value
            this.attrsSelect = item.val === '' ? -1 : item.val
          } else if (item.type == 7) {
            if (item.val) {
              this.date_picker.currentDate = new Date(item.val * 1000)
              this.date_picker.maxDate = new Date(2030, 1, 1)
            }
          } else if (item.type == 8) {
            if (timeRange) this.timeRange = timeRange
            this.date_picker.maxDate = new Date(2030, 1, 1)
          } else {
            // 多选
            sessionStorage.setItem('user_attrs', JSON.stringify(this.attrs))
            this.$router.push({
              name: 'SetInfo',
              query: {
                tag: 'attr',
                attr_id: item.id,
              },
            })
            return
          }
          break
      }
      this.showPopup = true
    },
    // app头像上传
    onAppUploadImg(type) {
      if (this.$store.state.app) {
        this.$pub.appAction('selectPhoto', { photoType: type })
        this.showPopup = false
      }
    },
    // h5头像上传
    onChangeAvatar(e) {
      const formdata = new FormData()
      const size = e.target.files[0].size / 1024 / 1024 < 5
      if (!size) {
        this.$toast('超过文件最大的大小')
        return
      }
      formdata.append('file', e.target.files[0])
      this.$http.post('/api/app/public/img', formdata).then((data) => {
        this.requestUpdateUserInfo({ avatar: data.path })
      })
      this.showPopup = false
    },
    // 单选确认
    onConfirmAttrs(value, index) {
      this.showPopup = false
      this.attrs[value.parentIdx].val = index
      this.updateAttrs()
    },
    // 多选获取已选名称组合
    getAttrsSelectExtendText(item) {
      if (item.type != 2) return ''
      if (item.val) {
        if (!item.val.length) return '请选择'
        let ret = []
        item.val.forEach((i) => {
          ret.push(item.value[i].text)
        })
        return ret.join('，')
      } else {
        return '请选择'
      }
    },
    // 时间选择器确认
    onConfirmBirthday(val) {
      this.showPopup = false
      if (this.changeTag == 'birthday') {
        this.requestUpdateUserInfo({ birthday: val.format('yyyy-MM-dd') })
      } else {
        if (this.attrs[this.currentItemIdx].type == 8) {
          if (this.timeRange == 'start_time') {
            this.attrs[this.currentItemIdx].val.start_time = val.format(
              'yyyy-MM-dd'
            )
          } else {
            this.attrs[this.currentItemIdx].val.end_time = val.format(
              'yyyy-MM-dd'
            )
          }
        } else {
          this.attrs[this.currentItemIdx].val = Date.parse(val) / 1000
        }
        this.updateAttrs()
      }
    },
    // 地址选择更新
    address(params) {
      this.requestUpdateUserInfo(params)
    },
    // 取消弹出层
    onCancel() {
      this.showPopup = false
    },
    // 数据初始化
    addVal(item, user_answer) {
      user_answer.forEach((it) => {
        if (it.attr_id == item.id) {
          switch (item.type) {
            case 1:
              for (let i = 0; i < item.value.length; ++i) {
                if (it.attr_val == item.value[i].id) {
                  item.val = i
                  break
                }
              }
              break
            case 2:
              let answer = it.attr_val.split(',')
              item.val = []
              answer.forEach((j, idx) => {
                for (let i = 0; i < item.value.length; ++i) {
                  if (j == item.value[i].id) {
                    item.val.push(idx + '')
                    break
                  }
                }
              })
              break
            case 3:
            case 4:
            case 6:
            case 7:
              item.val = it.attr_val
              item.val = it.attr_val
              break
            case 5:
              item.val = it
            case 8:
              it.start_time = it.start_time
                ? new Date(it.start_time * 1000).format('yyyy-MM-dd')
                : ''
              it.end_time = it.end_time
                ? new Date(it.end_time * 1000).format('yyyy-MM-dd')
                : ''
              item.val = it
              break
            case 9:
              if (it.attr_val) {
                item.val = [{ path: it.attr_val }]
              } else {
                item.val = []
              }
              break
            case 10:
              item.val = []
              if (it.attr_val) {
                it.attr_val = JSON.parse(it.attr_val)
                it.attr_val.length &&
                  it.attr_val.forEach((img) => {
                    item.val.push({
                      path: img,
                    })
                  })
              }
              break
          }
        }
      })
    },
    // 提交格式化
    updateAttrs() {
      const attrAry = []
      for (let i = 0; i < this.attrs.length; i++) {
        let item = this.attrs[i]
        let attr = {
          attr_id: item.id,
        }
        switch (item.type) {
          case 1:
            if (!this.RequiredNotice(item, 1)) {
              return
            }
            attr.attr_val_id = item.val !== '' ? item.value[item.val].id : ''
            break
          case 2:
            if (!this.RequiredNotice(item, 2)) {
              return
            }
            attr.attr_val_id = []
            if (item.val.length) {
              item.val.forEach((it) => {
                attr.attr_val_id.push(item.value[it].id)
              })
              attr.attr_val_id = attr.attr_val_id.join(',')
            } else {
              attr.attr_val_id = ''
            }
            break
          case 3:
          case 4:
          case 6:
          case 7:
            if (!this.RequiredNotice(item, 1)) {
              return
            }
            attr.attr_val_id = item.val
            break
          case 5:
            if (!this.RequiredNotice(item, 4)) {
              return
            }
            if (item.val.province_id) {
              for (let j in item.val) {
                attr[j] = item.val[j]
              }
            }
            break
          case 8:
            if (!this.RequiredNotice(item, 3)) {
              return
            }
            attr.start_time = item.val.start_time
              ? Date.parse(item.val.start_time) / 1000
              : ''
            attr.end_time = item.val.end_time
              ? Date.parse(item.val.end_time) / 1000
              : ''
            break
          case 9:
            if (!this.RequiredNotice(item, 2)) {
              return
            }
            if (item.val.length) {
              attr.attr_val_id = item.val[0].path
            } else {
              attr.attr_val_id = ''
            }
            break
          case 10:
            if (!this.RequiredNotice(item, 2)) {
              return
            }
            if (item.val.length) {
              attr.attr_val_id = []
              item.val.forEach((it) => {
                attr.attr_val_id.push(it.path)
              })
            } else {
              attr.attr_val_id = []
            }
            break
        }
        attrAry.push(attr)
      }
      this.requestUpdateUserInfo({
        user_attr: JSON.stringify(attrAry),
      })
    },
    // 必填验证
    RequiredNotice(item, type) {
      if (
        item.is_required == 1 &&
        this.attrs[this.currentItemIdx].id == item.id
      ) {
        switch (type) {
          case 1:
            if (item.val === '') {
              this.$toast(`请完善${item.attr}`)
              return false
            }
            break
          case 2:
            if (item.val.length === 0) {
              this.$toast(`请完善${item.attr}`)
              return false
            }
            break
          case 3:
            if (item.val.start_time && item.val.end_time) {
              return true
            } else {
              this.$toast(`请完善${item.attr}`)
              return false
            }
          case 4:
            if (item.val.province_id && item.val.address) {
              return true
            } else {
              this.$toast(`请完善${item.attr}`)
              return false
            }
        }
        return true
      } else {
        return true
      }
    },
    // 获取个人信息和动态属性数据
    async requestUserInfo() {
      let data = await this.$http.get('/api/app/userInfo')
      this.userInfo = data
      // 性别
      this.userInfo.sex_name = SexType.getValue(data.sex)
      // 生日
      if (!this.userInfo.birthday) {
        this.userInfo.birthday = '请选择'
      }
      // 城市
      if (!this.userInfo.province_name) {
        this.userInfo.province_name = '请选择'
      }
      // 动态属性
      this.attrs = []
      // 个人信息完整 调用获取积分接口
      let attrData = await this.$http.get('/api/app/module/attribute/1')
      attrData.forEach((i) => {
        i.idx = this.attrs.length
        i.value.length &&
          i.value.forEach((ci) => {
            ci.text = ci.name
            ci.parentIdx = this.attrs.length
          })
        switch (i.type) {
          case 1:
          case 3:
          case 4:
          case 6:
          case 7:
            i.val = ''
            break
          case 5:
          case 8:
            i.val = {}
            break
          default:
            i.val = []
            break
        }
        this.addVal(i, this.userInfo.attr)
        this.attrs.push(i)
      })
      this.showPopup = false
    },
    // 更新个人信息
    async requestUpdateUserInfo(params) {
      await this.$http.put('/api/app/user', params)
      this.$toast('数据更新成功')
      this.requestUserInfo()
    },
    // 绑定微信
    bindWx() {
      const url = location.protocol + '//' + location.host + '/h5'
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.mp_login.appId}&redirect_uri=${this.config.login_auth_url}/h5/login-middle?saas_redirect_url=${url}${this.$route.path}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
    },
    // 解绑微信
    async unBindWx() {
      this.$dialog
        .confirm({
          confirmButtonText:'确定',
          title: '提示',
          message:
            '解除绑定后将无法使用当前微信登录到此账号，确定要解除绑定吗？',
        })
        .then(async () => {
          await this.$http.get('/api/app/userUnbindingWx')
          this.$toast('解绑成功')
          this.requestUserInfo()
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.info {
  @extend %default-bg;
  ul {
    background: #fff;
    margin: 0;
    padding: 10px 30px 0;
    li {
      height: 110px;
      line-height: 110px;
      display: flex;
      justify-content: space-between;
      position: relative;
      span:nth-child(1) {
        font-size: 32px;
        color: #333;
        display: inline-block;
        text-align: left;
        width: 340px;
        @include eps;
      }
      span:nth-child(2) {
        font-size: 32px;
        color: #333;
        margin-right: 34px;
        display: inline-block;
        text-align: right;
        width: 300px;
        @include eps;
      }
      .default_color {
        color: #b3b3b3 !important;
      }
      span > img {
        width: 74px;
        height: 74px;
        border-radius: 50%;
        vertical-align: middle;
      }
      &:before {
        content: '';
        display: block;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%) rotate(45deg);
        width: 20px;
        height: 20px;
        border-top: 1px solid #b7b7b7;
        border-right: 1px solid #b7b7b7;
      }
      &:after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        height: 1px;
        background-color: #f5f5f5;
      }
    }
    .wechat {
      span:nth-child(1) {
        width: 120px;
      }
      span:nth-child(2) {
        width: 500px;
      }
      i {
        margin-left: 20px;
        color: #fc5623;
      }
    }
    .no-border:after {
      display: none;
    }
    .mobile:before {
      display: none;
    }
  }
  .popup {
    margin: 0;
    li {
      height: 92px;
      line-height: 92px;
      font-size: 34px;
      font-weight: 300;
      color: #030303;
      text-align: center;
      display: block;
      // position: relative;
      &:before {
        display: none;
      }
      input {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
      }
    }
  }
}
.get-user-info {
  .info-content {
    background: #fff;
    margin: 0;
    .specail-style {
      height: 88px;
      background: rgba(247, 247, 247, 1);
      font-size: 28px;
      color: rgba(102, 102, 102, 1);
      line-height: 88px;
      padding: 0 36px;
    }
    .cell {
      padding: 35px 36px;
      display: flex;
      flex-wrap: wrap;
      position: relative;
      justify-content: space-between;
      @include border-b1($border-color);
      &.avatar {
        align-items: center;
        padding: 0 36px;
        height: 110px;
      }
      span:nth-child(1) {
        width: 134px;
        padding-right: 36px;
        line-height: 40px;
        font-size: 32px;
        color: #333;
        display: inline-block;
        text-align: left;
      }
      span:nth-child(2) {
        max-width: 55%;
        line-height: 40px;
        font-size: 32px;
        color: #b3b3b3;
        margin-right: 30px;
        display: inline-block;
        @include eps;
        .upload-avatar {
          color: $theme_color;
        }
      }
      .span-hover {
        color: #666666 !important;
      }
      .st1 {
        font-size: 32px;
        color: #b3b3b3;
      }
      .input-type {
        flex: 1;
        height: 40px;
        font-size: 32px;
        line-height: 40px;
        padding: 0;
        margin: 0;
        border: 0;
      }
      span > img {
        width: 74px;
        height: 74px;
        border-radius: 50%;
        vertical-align: middle;
      }
      &:before {
        content: '';
        display: block;
        position: absolute;
        right: 30px;
        top: 43px;
        transform: rotate(45deg);
        width: 16px;
        height: 16px;
        border-top: 1px solid #797979;
        border-right: 1px solid #797979;
      }
      textarea {
        width: 100%;
        font-size: 32px;
        color: rgba(51, 51, 51, 1);
        line-height: 50px;
        border: 0;
        padding: 0;
        margin: 0;
      }
    }
    // 多图
    .mulit-img {
      &::before {
        display: none;
      }
      p {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding-bottom: 6px;
        .sp2 {
          margin: 0;
        }
      }
      .edit-content {
        padding: 30px 0;
        /deep/ .van-uploader__preview {
          margin-right: 30px;
          .van-uploader__preview-image {
            width: 206px;
            height: 206px;
          }
        }
        /deep/ .van-uploader__upload {
          width: 206px;
          height: 206px;
        }
      }
    }
    //个人简介
    .muit-line {
      &::before {
        display: none;
      }
      .p1 {
        width: 100%;
        line-height: 40px;
        font-size: 32px;
        color: #333;
      }
      .p2 {
        width: 100%;
        text-align: right;
        font-size: 26px;
        padding-top: 10px;
        color: rgba(128, 128, 128, 1);
      }
      textarea {
        padding-top: 20px;
        height: 130px;
      }
    }
    // 地址
    .address {
      height: 200px;
      box-sizing: border-box;
      textarea {
        height: 100%;
      }
    }
    .mobile::before,
    .address::before,
    .line-input::before {
      display: none;
    }
    .noborder {
      .cell::after {
        display: none;
      }
    }
  }
  .popup {
    margin: 0;
    li {
      height: 92px;
      line-height: 92px;
      font-size: 34px;
      font-weight: 300;
      color: #030303;
      text-align: center;
      display: block;
      // position: relative;
      &:before {
        display: none;
      }
      input {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
      }
    }
  }
}
/deep/ .attrs-checkbox {
  .attrs-checkbox-btn {
    display: flex;
    justify-content: space-between;
    color: $theme_color;
    font-size: 28px;
    border-bottom: 1px solid #f5f5f5;
    height: 80px;
    p {
      width: 80px;
      height: 80px;
      text-align: center;
      line-height: 80px;
    }
  }
  .attrs-checkbox-content {
    padding: 20px;
    .van-checkbox {
      height: 80px;
    }
    .van-checkbox__label {
      margin-left: 20px;
    }
  }
}
</style>
